import React from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import "./Home.css"; // CSS file for your styles
import ServiceCard from "../components/ServiceCard.js";
import heroImage from '../images/home_hero.webp';
import washingMachineImg from "../images/image1.webp";
import fridgeServiceImg from "../images/image2.jpg"; // Import the fridge image as well
  




const technicians = [
  {
    id: 1,
    name: 'Ram',
    
    skills: 'Specialist in Fridge Service',
    experience: '3+ years of experience in home appliance service',
    rating: 4.9,
    reviewsCount: 80,
    review: 'Ram provided exceptional service and fixed my fridge efficiently. Highly recommended!'
  },
  {
    id: 2,
    name: 'Kumar',
    
    skills: 'Expert in Washing Machine Repair',
    experience: '5+ years of experience in appliance repair',
    rating: 4.8,
    reviewsCount: 65,
    review: 'Kumar was professional and solved the washing machine issue quickly!'
  },
  {
    id: 3,
    name: 'Anil',
    
    skills: 'Specialist in Home Appliance Maintenance',
    experience: '4+ years in home appliance  services',
    rating: 4.7,
    reviewsCount: 92,
    review: 'Anil was prompt and did an excellent job with my home applianceGreat service!'
  }
];
function Home() {
  return (
    <>
   <div className="hero-container">
    <img src={heroImage} alt="Hero" className="hero-image" />
    <div className="hero-content">
        <div className="left-section">
            <h1 className="hero-title">Welcome to Home Appliance Service</h1>
            <p className="hero-description">
                We provide reliable and efficient home appliance repair services.
            </p>
            <button
                className="hero-button"
                onClick={() => window.location.href = 'tel:+918270096596'}
            >
                Book Now:  82700 96596
            </button> 
        </div>
    </div>
</div>




      {/* Service Cards Section */}
      <div className="service-cards-container">
        <h2>Our Services:</h2>
        <ServiceCard
          title="Washing Machine Repair"
          description="Reliable repair services for all washing machine brands."
          image={washingMachineImg} // Use the imported image variable here
        />
        <ServiceCard
          title="Fridge Service"
          description="Professional fridge servicing and maintenance to keep you cool."
          image={fridgeServiceImg} // Use the imported image variable here
        />
      </div>

      
<div class="our-process-section">
  <div class="process-row">
   
  {/* // <div class="process-image">
  //     <img src="your-image.jpg" alt="Our Process Image" class="responsive-image">
  //   </div> */}

   
    <div class="process-content">
      <h2>How We Work</h2>
      <p>Our home appliance service website operates effectively with the help of Google Ads. We specialize in washing machine and fridge repairs, offering these services through our website. When a customer searches for these services on Google, they may find us and easily contact us using the phone call option on our site.</p>
      <p>Once we receive a call, our customer support team promptly books the issue and assigns the registered complaint to one of our certified technicians. The technician then reaches the customer’s location directly, as we provide door-to-door service. In most cases, our technicians resolve the issue within 3 hours, charging only a service fee of 300 rupees.</p>
      <p>If any spare parts need replacement, our technician will discuss this with the customer. Upon the customer’s approval and agreement to market-priced spare parts with a bill, we proceed with the replacement. We also offer a warranty on both the parts and the service provided.</p>
      <p>In rare cases where a spare part is unavailable, we inform the customer and complete the repair within a day or two, ensuring maximum transparency. Our team is committed to delivering top-quality service with 100% customer satisfaction.</p>
    </div>
  </div>
</div>




      {/* Technician Experience Section */}
      <div className="technician-experience">
        <h2 className="technician-experience-title">Technician Qualifications & Experience</h2>
        <div className="experience-list">
          <div className="experience-item">
            <i className="fas fa-graduation-cap experience-icon"></i>
            <p>Certified Technicians with extensive training.</p>
          </div>
          <div className="experience-item">
            <i className="fas fa-briefcase experience-icon"></i>
            <p>5+ years of hands-on experience in appliance repairs.</p>
          </div>
          <div className="experience-item">
            <i className="fas fa-trophy experience-icon"></i>
            <p>Multiple industry certifications and recognitions.</p>
          </div>
          <div className="experience-item">
            <i className="fas fa-users experience-icon"></i>
            <p>High customer satisfaction with excellent reviews.</p>
          </div>
        </div>

        {/* CTA to Hire Technicians */}
        <div className="cta-section">
          <p>Want to work with our expert technicians? Contact us today for more details!</p>
          {/* Use Link instead of <a> to navigate to the Contact page */}
          <Link to="/contact" className="cta-button">Contact Us</Link>
        </div>
      </div>




      {/* Technician Responsibilities and Timing Section */}
      <div className="technician-section">
        <h2 className="technician-title">Technician Work & Responsibilities</h2>
        <div className="technician-responsibilities">
          <h3>Technician Responsibilities</h3>
          <div className="responsibilities-row">
            <div className="responsibility-item">
              <i className="fas fa-tools responsibility-icon"></i>
              <p>Inspect and diagnose the appliance issue thoroughly.</p>
            </div>
            <div className="responsibility-item">
              <i className="fas fa-file-invoice-dollar responsibility-icon"></i>
              <p>Provide an honest assessment and cost estimate for repairs.</p>
            </div>
            <div className="responsibility-item">
              <i className="fas fa-check-circle responsibility-icon"></i>
              <p>Ensure the appliance is working properly after repairs.</p>
            </div>
            <div className="responsibility-item">
              <i className="fas fa-cogs responsibility-icon"></i>
              <p>Offer maintenance tips to extend the appliance's lifespan.</p>
            </div>
          </div>
        </div>
        </div>

       
      
      <div className="appointment-process">
        <h4 className="appointment-heading">How to Book an Appointment</h4>
        <div className="appointment-steps">
          <div className="step-item">
            <i className="fas fa-phone-alt step-icon"></i>
            <p>Call us or send a message with your service request.</p>
          </div>
          <div className="step-item">
            <i className="fas fa-calendar-check step-icon"></i>
            <p>Schedule a convenient date and time for the service.</p>
          </div>
          <div className="step-item">
            <i className="fas fa-tools step-icon"></i>
            <p>Our technician will arrive as scheduled to provide the service.</p>
          </div>
        </div>
      </div>
    

            {/* Working Hours in a Row */}
            <div className="working-hours-container">
      <h2 className="working-hours-title"> Working Hours</h2>
      <table className="working-hours-table">
        <thead>
          <tr>
            <th>Day</th>
            <th>Time</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><i className="fas fa-calendar-day timing-icon"></i> Monday - Friday</td>
            <td>9:00 AM - 7:00 PM</td>
          </tr>
          <tr>
            <td><i className="fas fa-calendar-day timing-icon"></i> Saturday</td>
            <td>9:00 AM - 6:00 PM</td>
          </tr>
          <tr>
            <td><i className="fas fa-calendar-day timing-icon"></i> Sunday</td>
            <td> Sunday Also Working</td>
          </tr>
        </tbody>
      </table>
    </div>

         
        
     

    <div className="technician-profiles-section">
  <h2 className="section-title"> Expert Technicians</h2>
  <div className="profiles-grid">
    {technicians.map((tech) => (
      <div key={tech.id} className="technician-card">
        {/* Profile Icon */}
        <div className="profile-icon">
          <i className="fas fa-user-circle"></i>
        </div>
        
        {/* <img src={tech.photo} alt={tech.name} className="technician-photo" /> */}
        <h3 className="technician-name">{tech.name}</h3>
        <p className="technician-skills">{tech.skills}</p>
        <p className="technician-experience">{tech.experience}</p>
        <div className="technician-rating">
          <i className="fas fa-star"></i> {tech.rating}/5 ({tech.reviewsCount} reviews)
        </div>
        <blockquote className="customer-review">"{tech.review}"</blockquote>
      </div>
    ))}
  </div>
</div>





    </>
  );
}

export default Home;
